export type TUserAvatar = {
  createdAt: string,
  uuid: string,
  mimeType: string,
  type: string,
  ownerId: number,
  extension: string,
  uri: string,
};

export type TUser = {
  id: number,
  email: string,
  roles: string[],
  fullName: string,
  firstName: string,
  lastName: string,
  phone: string | null,
  avatar: TUserAvatar | null,
  userNotification: {
    countNotReadNotifications: number,
    lastReadNotificationId: string | null,
    mercureTopic: string | null,
  },
};

export const ACCESS_TOKEN_STORAGE_NAME = 'ACCESS_TOKEN_STORAGE';
